export default "__VITE_ASSET__J5dtmvdC__"